export default "__VITE_ASSET__83819043__"